import * as v from 'valibot';
import { secret } from './domain-string.js';
export const ProofOfWorkToken = secret('proof-of-work-token');
export const ChallengeConfig = v.object({
    c: v.number(),
    s: v.number(),
    d: v.number(),
});
export const ChallengeData = v.object({
    challenge: ChallengeConfig,
    expires: v.number(),
});
export const CaptchaSolution = v.object({
    token: ProofOfWorkToken,
    solutions: v.array(v.number()),
});
export const ChallengeResponse = v.object({
    challenge: ChallengeConfig,
    token: ProofOfWorkToken,
    expires: v.number(),
});
export const RedemptionResponse = v.object({
    success: v.boolean(),
    message: v.optional(v.string()),
    token: v.optional(ProofOfWorkToken),
    expires: v.optional(v.number()),
});
export const ValidationResponse = v.object({
    success: v.boolean(),
});
//# sourceMappingURL=cap.js.map